import { TouchableOpacity, View } from 'react-native';
import React, { useMemo } from 'react';
import { Text } from '~/components';
import { formatMoney } from '~/utils';

interface Props extends Checkout.Installment {
  isFirst: boolean;
  value?: Checkout.Installment;
  onPress: () => void;
}

const Installment = ({
  id,
  description,
  price,
  totalPrice,
  isFirst,
  value,
  onPress,
}: Props) => {
  const isSelected = useMemo(() => value?.id === id, [id, value]);

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      className={`py-4 rounded-md flex-row items-center justify-between border-b border-b-gray-100 ${
        isFirst ? 'border-t border-t-gray-100' : ''
      }`}
      onPress={onPress}
    >
      <View className="w-[100%]">
        <Text
          className={`${
            isSelected ? 'text-primary-600' : 'text-gray-600'
          } text-xs font-medium`}
        >
          {description}
        </Text>

        <View className="py-2 flex-row items-center justify-between">
          <View className="flex-row items-baseline">
            <Text
              className={`text-xl font-medium ${
                isSelected ? 'text-primary-600' : 'text-gray-600'
              }`}
            >
              {formatMoney(price, true)}
            </Text>
            <Text
              className={`text-sm font-normal ${
                isSelected ? 'text-primary-600' : 'text-gray-600'
              }`}
            >
              /mês
            </Text>
          </View>

          <View
            className={`w-5 h-5 border border-gray-400 rounded-xl items-center justify-center ${
              isSelected ? 'bg-primary-20 border-primary-20' : 'bg-white'
            }`}
          >
            {isSelected && (
              <View className="w-[10px] h-[10px] bg-primary-600 rounded-md" />
            )}
          </View>
        </View>

        {!!totalPrice && (
          <Text
            className={`text-[11px] ${
              isSelected ? 'text-primary-600' : 'text-gray-600'
            }`}
          >{`Total: ${
            typeof totalPrice === 'number'
              ? formatMoney(totalPrice, true)
              : totalPrice
          }`}</Text>
        )}
      </View>
    </TouchableOpacity>
  );
};

export default Installment;
